import dayjs from "dayjs";
import { AvailabilitySlot, UserAvailabilityArrayData } from "@/types";

export const DaysEng = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const MAX_REMINDER_LIMIT = 3;
export const REMINDER_STORAGE_KEY = "availabilities_reminder";
export const MonthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const DaysShort = [
  "days_short.monday",
  "days_short.tuesday",
  "days_short.wednesday",
  "days_short.thursday",
  "days_short.friday",
  "days_short.saturday",
  "days_short.sunday",
];

export const Days = [
  "days.monday",
  "days.tuesday",
  "days.wednesday",
  "days.thursday",
  "days.friday",
  "days.saturday",
  "days.sunday",
];

/**
 * It returns an array of 14 strings, each string representing a time in the format of "HH:mm" starting
 * from 8:00am
 * @returns An array of strings, each string representing a time in the format HH:mm.
 */
export const getTime = () => {
  const time = dayjs().hour(8).minute(0);
  return Array(14)
    .fill(0)
    .map((_i, idx) => time.add(idx, "hour").format("HH:mm"));
};

export const excludeDate = (value: { day: string; time: string }) => {
  // Block Sat/Sun from 19:00 to 21:00 (inclusive)
  const excludeTimes = ["19:00", "20:00", "21:00", "22:00"];
  if (
    (value.day === "Sun" || value.day === "Sat") &&
    excludeTimes.includes(value.time)
  ) {
    return true;
  }
  return false;
};

export const generateSlots = (): AvailabilitySlot[] => {
  const times = getTime();
  return Array.from({ length: 98 }, (_, i) => {
    return {
      value: { day: DaysEng[i % 7], time: times[Math.floor(i / 7)] },
      isSelected: excludeDate({
        day: DaysEng[i % 7],
        time: times[Math.floor(i / 7)],
      }),
      id: "slot" + i,
    };
  });
};

export const generateSlotsExistingAvailabilities = (
  data: UserAvailabilityArrayData[],
): AvailabilitySlot[] => {
  return data[0]?.Stringa.map((a, idx) => {
    const dataTime = a.id.split(" ");
    const serverDayIndex = Number(dataTime[2]);

    const day = DaysEng[serverDayIndex];

    const time = dataTime[1];
    const shouldExcludeByRule = excludeDate({ day, time });
    return {
      value: { day, time },
      isSelected: !a.status || shouldExcludeByRule,
      id: "slot" + idx,
    };
  });
};

export const validateSlots = (values: AvailabilitySlot[]) => {
  const numberOfAvailableSlots = values.filter((r) => !r.isSelected).length;
  //
  if (numberOfAvailableSlots >= 12) {
    const daysSelected: string[] = [];
    values.forEach((item) => {
      if (!daysSelected.includes(item.value.day) && !item.isSelected) {
        daysSelected.push(item.value.day);
      }
    });
    return daysSelected.length >= 3;
  }
  return false;
};

export const sortSlotsIntoDays = (slots: AvailabilitySlot[]) => {
  const r: Record<string, AvailabilitySlot[]> = {};

  slots.flat().forEach((slot) => {
    const day = slot.value.day;
    if (!r[day]) {
      r[day] = [];
    }
    r[day].push(slot);
  });

  return Object.values(r).flat();
};
